<script>
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";

export default {
  name: "WithdrawalPoint",
  components: { GridRow, GridCol },
  props: {
    withdrawalPoints: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  }
};
</script>

<template>
  <div class="u-mb-md@md">
    <GridRow class="u-mt-lg">
      <GridCol
        cols="6"
        md="12"
        v-for="withdrawalPoint in withdrawalPoints"
        :key="withdrawalPoint.id"
        class="u-mb-md"
      >
        <p class="u-mb-xxs">
          <strong class="u-font-500"> {{withdrawalPoint.description}}
          </strong>
        </p>
        <p class="u-mb-xxs">{{withdrawalPoint.adresse}}</p>
      </GridCol>
    </GridRow>
  </div>
</template>

<style lang="scss" scoped>
</style>
